import { render } from "./UsersContainer.vue?vue&type=template&id=66b3dfd3"
import script from "./UsersContainer.vue?vue&type=script&lang=js"
export * from "./UsersContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__